export default async function () {
  // TODO: wait on status: 500 / 503
  // redirect to error 500 / 503 (throw)
}
